import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthService } from '../shared/core/index';
import { HttpService } from '../shared/core/http.service';

export interface DashboardCardDto {
  Id: number;
  DashboardId: number;
  Label: string;
  Type: string;
  DisplayOrder: number;
  Count: number;
  CreatedDate: string;
  CreatedById: string;
  LastModifiedDate: string;
  LastModifiedById: string;
}

export interface DashboardDto {
  Id: number;
  Name: string;
  Type: string;
  Department: string;
  SFProjectId: string;
  UserId: string;
  Default: boolean;
  CreatedDate: string;
  CreatedById: string;
  LastModifiedDate: string;
  LastModifiedById: string;
  Cards: DashboardCardDto[];
}

export interface DashboardCardCreateDto {
  Label: string;
  Type: string;
}

export interface DashboardCreateDto {
  Name: string;
  Type: string;
  Department: string;
  SFProjectId: string;
  UserId: string;
  Default: boolean;
  Cards: DashboardCardCreateDto[];
}

export interface DashboardCardUpdateDto {
  Id: number;
  Label: string;
  Type: string;
}

export interface DashboardUpdateDto {
  Name: string;
  Default: boolean;
  Cards: DashboardCardUpdateDto[];
}

@Injectable()
export class DashboardService {

  constructor(private _authService: AuthService, private _httpService: HttpService) {}

  getDashboards(projectId: string): Observable<DashboardDto[]> {
    const userRoles = this._authService.userRoles;
    return this._httpService.httpGet(
      this._authService.API_URL + 'Dashboard/user/projects/' + projectId,
      userRoles
    );
  }

  getAllProjectDashboards(projectId: string): Observable<DashboardDto[]> {
    const userRoles = this._authService.userRoles;
    return this._httpService.httpGet(
      this._authService.API_URL + 'Dashboard/projects/' + projectId + '/all',
      userRoles
    );
  }

  createDashboard(dto: DashboardCreateDto): Observable<any> {
    const userRoles = this._authService.userRoles;
    return this._httpService.httpPost(this._authService.API_URL + 'Dashboard', dto, userRoles);
  }

  updateDashboard(id: number, dto: DashboardUpdateDto): Observable<any> {
    return this._httpService.httpPut(this._authService.API_URL + 'Dashboard/' + id, dto);
  }

  deleteDashboard(id: number): Observable<any> {
    return this._httpService.httpDelete(this._authService.API_URL + 'Dashboard/' + id);
  }

  setDefaultDashboard(dashboardId: number, projectId?: string): Observable<any> {
    let url = this._authService.API_URL + 'Dashboard/' + dashboardId + '/set-default';
    if (projectId) {
      url += '?projectId=' + encodeURIComponent(projectId);
    }
    return this._httpService.httpPut(url, {});
  }
}
